import agendaApiConfig from "./agendaApiConfig";

const SpecialityService = {
    async getAll () {
        //return await agendaApiConfig.get("/especialidad");
        console.log("especialidad API getAll ....")
        let query =  {}; 
        if(process.env.REACT_APP_SERVICIO == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO }; 
        }
        console.log("QUERY SpecialityService/getAll => ", query);
        return await agendaApiConfig.get("/especialidad", {
            params: {
                ...query
            }
        });
    },
    async getByService (codeService) {
        //return await agendaApiConfig.get("/especialidad");
        console.log("especialidad API getByService ...." , codeService);
        let query =  {}; 
        // if(process.env.REACT_APP_SERVICIO == ""){
        //     query = null;
        // }else{
        //     query =  {ser_codigo : codeService }; 
        // }
        query =  {SER_CODIGO : codeService }; 
        return await agendaApiConfig.get("/especialidad", {
            params: {
                ...query
            }
        });
    },    
    async getProfessionals(codeSpeciality = 0) {
        //return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`);
        let query =  {}; 
        if(process.env.REACT_APP_SERVICIO == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO }; 
        }
        return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`, {
            params: {
                ...query
            }
        });
    },
    async getProfessionalsByService(codeSpeciality = 0, codeService) {
        //return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`);
        let query =  {}; 
        if(codeService == null){
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO };             
        }else{
            //query = null;
            query =  {SER_CODIGO : codeService }; 
        }
        //query =  {SER_CODIGO : codeService }; 
        console.log("QUERY => ", query);
        return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`, {
            params: {
                ...query
            }
        });
    }    
}

export default SpecialityService;